import { API_RESULT_TYPE } from '@/models/entities/api/api-result-type';

export default class ApiLocked {
  apiResultType: typeof API_RESULT_TYPE.LOCKED;

  constructor() {
    this.apiResultType = API_RESULT_TYPE.LOCKED;
  }
}
